import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ErrorAnimation.module.css';
export default function ErrorAnimation() {
    return (_jsx("div", { className: styles.icon, children: _jsxs("div", { className: styles.iconError, children: [_jsxs("div", { className: styles.iconErrorX, children: [_jsx("div", { className: styles.iconErrorLeft }), _jsx("div", { className: styles.iconErrorRight })] }), _jsx("div", { className: styles.iconErrorPlaceholder }), _jsx("div", { className: styles.iconErrorFix })] }) }));
}
